<template>
   <div>

   </div>
</template>
<script>
   import c from "Vue/Core/constants.js"
   export default {
     name: "callback",
     data() {
         return {
               accessToken:'',
               refreshToken:'',
               userData: [],
               email: '',
               consultantId : '',
               organizationLength:'',
               isEssEnabled: true
         }
     },
      created() {
          this.$loading({ 'loadingText': 'Loading...' })
           let userId = this.$route.query.code
           if(userId != '' && userId != null && userId != undefined){
               this.getAccessToken(userId);
           }
         },

         methods:{
               getAccessToken(id){
                    // ajax.get( c.APIBASEURL + `GetESSToken?id=${id}`, {}, (res) => {
                    //     if(res.data.State){
                    //         this.accessToken = res.data.UserTokenModel.AccessToken
                    //         this.refreshToken = res.data.UserTokenModel.RefreshToken
                    //         this.getUserDetails(this.accessToken)
                    //     }
                    // })
                 axios.get(c.APIBASEURL + `/GetESSToken?id=${id}`, {}, {}).then((res) => {
                    if(res.data.State){
                        this.accessToken = res.data.UserTokenModel.AccessToken
                        this.refreshToken = res.data.UserTokenModel.RefreshToken
                        this.userId = res.data.UserTokenModel.UserId
                        this.consultantId = res.data.UserTokenModel.UserId
                        this.email = res.data.Email
                        this.loginMethod()
                        //this.getUserDetails(this.accessToken)
                     }
                }).catch(error => {
                    return Promise.reject(error)
                });
               },
               getUserDetails(val){
                //    ajax.get( c.APIBASEURL + `WSO2UserInfo?token=` + val, {}, (res) => {
                //         if(res.data.State){
                //             this.email = res.data.nameid
                //             this.loginMethod()
                //         }
                //     })
                axios.get(c.APIBASEURL + `/WSO2UserInfo?token=` + val, {}, {}).then((res) => {
                    if(res.data.State){
                        this.email = res.data.nameid
                        this.loginMethod()
                    }
                }).catch(error => {
                    return Promise.reject(error)
                });
               },
               redirectToPage() {
                    let redirectPath = this.$route.query.redirect
                    if(redirectPath && redirectPath != '') {
                        this.$router.push({'path': redirectPath})
                    } else if(this.organizationLength > 1 ) {
                        this.$router.push({'name':'SelectOrganization'})
                    }
                    else{
                        // window.createConnection()
                        this.$router.push({'name':'ess-dashboard'})
                    }
                },
                // isLoggedIn() {
                //     if(session.isActive()) {
                //         window.createConnection()
                //         this.$router.push({'name': 'ess-dashboard'})
                //     }
                //     else if(localStorage.getItem('isESSDisabled')){
                //         this.isEssEnabled = false
                //         localStorage.removeItem('isESSDisabled')
                //     }
                //     else{
                //         this.userMessage = localStorage.getItem("expiry_message")
                //         localStorage.removeItem("expiry_message")
                //     }
                // },
                loginMethod() {
                  //
                    // Login success
                    // Store access_token in localstorage
                    localStorage.setItem("access_token",  this.accessToken)
                    localStorage.setItem("refresh_token", this.refreshToken)
                    // Refresth the access token
                    ajax.refreshAccessToken()
                    session.create()
                    //get organization list api
                    //this.org = true

                    //ajax.get(`Employee/${this.email}/RedirectToOrganization`, {}, (res) => {
                    //var OrgId = res.data
                    //this.organizationId = OrgId
                    //if(OrgId == '' ){
                        // ajax.get(`Employee/${this.email.toLowerCase()}/EmployeeOrganizationList`, {}, (res) => {
                        ajax.get(`Employee/${this.consultantId}/EmployeeOrganizationList`, {}, (res) => {
                          if (res.data.State == true) {
                             var employee = res.data.organizationBasicInfoList.EmployeeInfo
                             var organization = res.data.organizationBasicInfoList.OrganizationInfo
                             this.organizationLength = organization.length
                             var orgId = res.data.organizationBasicInfoList.OrganizationInfo[0].Id
                        if( employee && organization && organization.length > 1){
                            this.$loading({}).close()
                            var userObj = {}
                            userObj.email = this.email.toLowerCase()
                            userObj.empId = employee.Id
                            userObj.name = employee.Name
                            userObj.designation = employee.Designation
                            userObj.profilepic = employee.ProfilePicLink
                            userObj.consultantId = this.consultantId
                            //userObj.SelectOrg = false
                            localStorage.setItem("user_details", JSON.stringify(userObj))
                            // update the employee details
                            ajax.updateUserDetails()
                            this.redirectToPage()
                        }
                        else{
                            if(!res.data.organizationBasicInfoList.OrganizationInfo[0].IsEssValidated){
                            this.$loading({}).close()
                            var userObj = {}
                            userObj.email = this.email.toLowerCase()
                            userObj.empId = employee.Id
                            userObj.name = employee.Name
                            userObj.designation = employee.Designation
                            userObj.profilepic = employee.ProfilePicLink
                            userObj.consultantId = this.consultantId
                            localStorage.setItem("user_details", JSON.stringify(userObj))
                            // update the employee details
                            ajax.updateUserDetails()
                            this.$router.push({'name':'SelectOrganization'})
                            }else{
                            this.ESSEnableDisable(res)
                            ajax.get(`/Employee/GetEmployeeDetails?orgId=${orgId}`, {}, (res) => {
                                this.$loading({}).close()
                                if (res.data.State == true) {
                                var userObj = {}
                                userObj.empId = res.data.EmpId
                                userObj.name = res.data.EmployeeContact.FirstName + ' ' + res.data.EmployeeContact.LastName
                                userObj.email = res.data.EmployeeContact.Email
                                userObj.orgId = res.data.OrgId
                                userObj.consultantId = res.data.ConsultantId
                                userObj.profilepic = res.data.ProfilePicLink
                                userObj.designation = res.data.Designation
                                userObj.IsH1B = res.data.IsH1B
                                userObj.OrgName = res.data.OrgName
                                userObj.OrgWebSite = res.data.OrgWebsite
                                userObj.HireType = res.data.HireType
                                userObj.IsSupervisor = res.data.IsSupervisor
                                //userObj.SelectOrg = false
                                //userObj.SingleOrg = true
                                // Update the employee details in local storage
                                localStorage.setItem("user_details", JSON.stringify(userObj))

                                // update the employee details
                                ajax.updateUserDetails()
                                // redirect to page
                                this.redirectToPage()

                                // show success message
                                // this.$message({
                                //   type: "success",
                                //   message: "Signed In successfully!"
                                // });
                                }
                                else
                                this.ESSEnableDisable(res)

                            })
                            }
                        }
                        }
                        else{
                        this.$loading({}).close()
                        this.ESSEnableDisable(res)
                        this.userMessage = res.data.Message
                         this.$message({
                            type: 'error',
                            message: res.data.Message
                        })
                        }
                    })
                    //}
                },
         }

   };
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/Callback.vue